var exports = {
  "IW": "VoiceParticipantAvatarList.module__stackAvatar___bl9GY2",
  "K_": "VoiceParticipantAvatarList.module__stackAvatarSpeaking___bl9GY2",
  "Eh": "VoiceParticipantAvatarList.module__wrapContainer___bl9GY2",
  "EN": "VoiceParticipantAvatarList.module__wrapAvatarSlot___bl9GY2",
  "FU": "VoiceParticipantAvatarList.module__wrapAvatarSlotAnimated___bl9GY2",
  "ee": "VoiceParticipantAvatarList.module__wrapAvatar___bl9GY2",
  "lE": "VoiceParticipantAvatarList.module__wrapAvatarAnimated___bl9GY2",
  "i1": "VoiceParticipantAvatarList.module__remainingCount___bl9GY2",
  "jC": "VoiceParticipantAvatarList.module__popoutContainer___bl9GY2",
  "qE": "VoiceParticipantAvatarList.module__popoutList___bl9GY2",
  "Az": "VoiceParticipantAvatarList.module__popoutRow___bl9GY2",
  "ps": "VoiceParticipantAvatarList.module__popoutRowAvatar___bl9GY2",
  "fU": "VoiceParticipantAvatarList.module__popoutRowName___bl9GY2",
};

module.exports = exports;
